<!-- <p>parsing-building-from-json works!</p> -->

<!-- <h1>Image Test</h1>
<img [src]="imageURL" width="500px" height="500px">

<br>

<code>{{imageURL}}</code>

<div id="i" 
     class=".background-image"
     [ngStyle]="{'background-image': imageURL}">
></div> -->
<span *ngIf="this.proj.sehelProjId && this.user">
     <button *ngIf="this.user.roles.editor && this.user.compId === this.companyId || this.user.roles.admin "
          (click)="startCheckForUpdates()" class="fa fa-download download-btn"></button>
</span>
<!-- <button style="display:none;" (click)="refreshTokenAndGetResponse()">token123</button> -->